import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

if (document.querySelector('.quotations-slider')) {
    const swiper = new Swiper('.quotations-slider .swiper', {
        modules: [Navigation, Pagination, Autoplay],
        loop: true,
        speed: 700,
        spaceBetween: 16,
        slidesPerView: 1,
        autoplay: {
            delay: 8000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        pagination: {
            el: '.quotations-slider .swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '">0' + (index + 1) + '</span>';
            },
        },

    });
}
